import renderWidgets from './widgets';
import WidgetMap from './WidgetMap';
const defaultWidgets = (props) => renderWidgets(Object.assign(Object.assign({}, props), { componentMap: WidgetMap }));
export default defaultWidgets;
